import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsWorkOrderSource, PmsWorkOrderSource } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsWorkOrderSource>
    useData={usePmsWorkOrderSource}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
